import { render, staticRenderFns } from "./urgentorder-edit.vue?vue&type=template&id=70b3fc54&"
import script from "./urgentorder-edit.vue?vue&type=script&lang=ts&"
export * from "./urgentorder-edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports